import React from 'react';
import PropTypes from 'prop-types';

import FeatureToggle from '@stubhub/react-feature-toggle';
import {connect} from '@stubhub/react-store-provider';

// Const isPaper = (fulfillmentMethodId) => [10, 11, 12].includes(fulfillmentMethodId);

const mapStateToProps = (state) => {
  return {
    featureflags: state.featureflags || {},
  };
};

export default function CheckoutIntegrationHoc(ReactComponent) {
  @connect({mapStateToProps})
  class WithComponent extends React.Component {
    render() {
      const {featureflags, ...rest} = this.props;

      return (
        <FeatureToggle name="common.enableSpeedyCheckout">
          {(on) => <ReactComponent hrefPrefix={`/${on ? 'checkout' : 'buy'}/review`} {...rest} />}
        </FeatureToggle>
      );
    }
  }

  WithComponent.propTypes = {
    /**
     * Feature flags object
     */
    featureflags: PropTypes.object,
  };

  WithComponent.displayName = 'CheckoutIntegrationHoc';

  return WithComponent;
}
